import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "27",
  height: "26",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "m4.44 3.723 9.468 9.285-9.398 9.37a2.3 2.3 0 0 1-.353-.663 2.7 2.7 0 0 1 0-.818V4.95c-.028-.428.07-.856.282-1.227m13.548 5.235-3.09 3.062-9.357-9.2c.304-.106.629-.135.946-.085.499.136.974.346 1.41.62l8.468 4.686c.55.296 1.087.606 1.623.917m-3.09 5.052 3.076 3.02-2.23 1.242-6.802 3.78c-.563.311-1.129.608-1.68.947a1.95 1.95 0 0 1-1.594.212zm7.974-1.002a2.08 2.08 0 0 1-1.073 1.863l-2.541 1.41-3.345-3.273 3.359-3.33c.86.48 1.708.96 2.554 1.411a2.05 2.05 0 0 1 1.046 1.919"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }